import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '../../DTO__generation_tool';
import { ENUM__image_asset_category } from '../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../_fields/image/FIELD__image_asset';
import { DTO_GRAPH__instance } from '../_graph/DTO_GRAPH__instance';
import { GENERATION_TOOL__image_edit__trim_color } from './image_edit/GENERATION_TOOL__image_edit__trim_color';
import { GENERATION_TOOL__image_mask__create_gradient } from './image_mask/GENERATION_TOOL__image_mask__create_gradient';
import { GENERATION_TOOL__vision__color_map } from './vision__color_map/GENERATION_TOOL__vision__color_map';
import { GENERATION_TOOL__vision_depth } from './vision__depth/GENERATION_TOOL__vision_depth';
import { GENERATION_TOOL__vision__canny_semi_auto } from './vision__line__canny/GENERATION_TOOL__vision__canny_semi_auto';

export function FN_GENERATION_TOOL__create_for_field_consumer(field_consumer: FIELD__image_asset, graph_consumer: DTO_GRAPH__instance) {
  let out = DTO__generation_tool.CREATE_STUB();

  if (graph_consumer.is_stub()) return out;
  if (field_consumer.is_stub()) return out;
  if (!field_consumer.image__is_initialized) return out;

  switch (field_consumer.category) {
    case ENUM__image_asset_category.IMAGE:
      out = GENERATION_TOOL__image_edit__trim_color();
      break;
    case ENUM__image_asset_category.MASK:
      out = GENERATION_TOOL__image_mask__create_gradient();
      break;
    case ENUM__image_asset_category.LINE__CANNY:
      out = GENERATION_TOOL__vision__canny_semi_auto();
      break;
    case ENUM__image_asset_category.DEPTH:
      out = GENERATION_TOOL__vision_depth.create();
      break;
    case ENUM__image_asset_category.COLOR_MAP:
      out = GENERATION_TOOL__vision__color_map();
      break;
    case ENUM__image_asset_category.ANY:
      // do nothing
      break;
    default:
      not_implemented_type(field_consumer.category);
  }

  return out;
}
